<template>
    <div class="pokemon-swiper-container" :style="{height: data.length > 0 ? swiperHeight + 'px' : 'auto'}">
        <!-- swiper (nekonecny, s prev/next sipkami) se zapne az od 2 pokemonu - s jedinym by nekonecne listovani nedavalo smysl -->
        <template v-if="data.length > 1">
            <v-btn
                class="pokemon-swiper-nav pokemon-swiper-nav--prev pic-bg-obstacle font-weight-bold"
                fab
                size="40"
                color="text-primary"
                @click="$refs.swiperRef.$swiper.slidePrev()"
            >
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>

            <Swiper
                ref="swiperRef"
                class="swiper ma-1 pa-1"
                v-if="swiperOption"
                :options="swiperOption"
                :style="{height: swiperHeight + 'px'}"
            >
                <swiper-slide v-for="pokemon in data" :key="pokemon">
                    <PokemonManager
                        style="width: 100%;"
                        :height-image="cardHeight"
                        :updater="updater"
                        :key="pokemon"
                        :pokemon-id="pokemon"
                        :in-fight="inFight"
                        :delete-pokemon-callback="deletePokemonCallback"
                        :update-pokemon="onPokemonUpdated"
                        :stones="stones"
                        :items="effectItems"
                        :isFullPool="false"
                        @item-use-error="$emit('item-use-error', $event)"
                    />
                </swiper-slide>
            </Swiper>

            <v-btn
                class="pokemon-swiper-nav pokemon-swiper-nav--next pic-bg-obstacle font-weight-bold"
                fab
                size="40"
                color="text-primary"
                @click="$refs.swiperRef.$swiper.slideNext()"
            >
                <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
        </template>

        <PokemonManager
            v-else-if="data.length === 1"
            style="width: 100%;"
            :height-image="swiperHeight"
            :updater="updater"
            :key="data[0]"
            :pokemon-id="data[0]"
            :in-fight="inFight"
            :delete-pokemon-callback="deletePokemonCallback"
            :update-pokemon="onPokemonUpdated"
            :stones="stones"
            :items="effectItems"
            :isFullPool="false"
            @item-use-error="$emit('item-use-error', $event)"
        />
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {mapActions} from 'vuex';
import PokemonManager from "@/components/pokemon/PokemonManager";
import 'swiper/swiper.scss';

export default {
    name: 'swiper-example-multiple-swipers',
    title: 'Multiple swipers',
    components: {
        PokemonManager,
        Swiper,
        SwiperSlide
    },
    props: {
        data: {Object, default: {}},
        inFight: {type: Boolean, default: false},
        deletePokemonCallback: {type: Function, default: function(){}},
        updater: {type: Number, default: 0},
        stones: {type: Array, default: () => []},
        effectItems: {type: Array, default: () => []},
        // true kdyz je "Pokemons" prave aktivni tab (TrainerBag.vue) - tab pilulky nad swiperem se mohou zalomit AZ PO prvnim zmereni, prepocet pri aktivaci to opravi
        active: {type: Boolean, default: false},
    },
    data() {
        return {
            // vertical + nested (vnoreno uvnitr vodorovneho tab-swiperu v TrainerBag.vue), at se svisle listovani pokemony a vodorovne prepinani zalozek gestacne nebiji
            // 1.15 misto celociselnych 2 - PokemonManager karta ma vnitrek kalibrovany na pevnou vysku ~360-400px, presna polovina uz prekryvala prvky (Lvl/Exp box pres nohu pokemona)
            slidesPerViewPeek: 1.15,
            swiperOption: {
                direction: 'vertical',
                loop: true,
                nested: true,
                slidesPerView: 1.15,
                spaceBetween: 16,
            },
            swiperHeight: 420,
        }
    },
    computed: {
        cardHeight() {
            const gapFraction = (this.slidesPerViewPeek - 1) * this.swiperOption.spaceBetween;
            return Math.max(160, Math.floor((this.swiperHeight - gapFraction) / this.slidesPerViewPeek));
        },
    },
    watch: {
        active(isActive){
            if (isActive) {
                this.$nextTick(this.updateSwiperHeight);
            }
        },
    },
    mounted() {
        this.updateSwiperHeight();
        window.addEventListener('resize', this.updateSwiperHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateSwiperHeight);
    },
    methods: {
        ...mapActions({
            refreshActiveTeam: 'pokemon/refreshActiveTeam',
        }),
        // zmerena skutecna pozice + dopocet do konce viditelne oblasti (ne window.innerHeight - pod .trainer-detail-page__scroll jeste sedi fixni TeamBottomSheet, jejiz misto uz je odectene pres CSS)
        updateSwiperHeight() {
            if (!this.$el || typeof this.$el.getBoundingClientRect !== 'function') {
                return;
            }
            const top = this.$el.getBoundingClientRect().top;
            const scrollContainer = this.$el.closest('.trainer-detail-page__scroll');
            const visibleBottom = scrollContainer
                ? scrollContainer.getBoundingClientRect().bottom
                : ((window.visualViewport && window.visualViewport.height) || window.innerHeight);
            const next = Math.max(360, Math.floor(visibleBottom - top - 4));
            if (next === this.swiperHeight) {
                return;
            }
            this.swiperHeight = next;
            // zmena vysky pres Vue :style neposila swiperu zadnou udalost (spoleha jen na window "resize") - bez rucniho update() by zustal se stara rozmerem
            this.$nextTick(() => {
                const swiper = this.$refs.swiperRef && this.$refs.swiperRef.$swiper;
                if (swiper) {
                    swiper.update();
                }
                // outer tab-swiper (TrainerBag.vue) prepocitava autoHeight jen pri zmene slidu/resize, ne pri zmene DOM uvnitr aktualniho slidu
                this.$emit('layout-changed');
            });
        },
        // ignoruje payload z PokemonManager (jina serializacni skupina nez co TeamBottomSheet cte) - radsi plny refetch nez shallow-merge nekompatibilnich tvaru
        onPokemonUpdated() {
            this.refreshActiveTeam();
        },
    },
}
</script>

<style lang="scss" scoped>

.pokemon-swiper-container {
    container-type: inline-size;
    position: relative;
    width: 100%;
}

.swiper {
    width: 100%;

    .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-weight: bold;
        /* swiper.scss deda do Vuetify komponent content-box (viz stejny fix v TrainerBag.vue) - rozhazoval by procentualni rozlozeni */
        box-sizing: border-box;
    }
}

.pokemon-swiper-nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
    color: darkorange;
}

.pokemon-swiper-nav--prev {
    top: 4px;
}

.pokemon-swiper-nav--next {
    bottom: 4px;
}

</style>
